import { CauseEvidence } from '../interfaces/Organization';

export class MCauseEvidence{
    public name: string = null;
    public base64: string = null;
    public id: number = null;
    public url: string = null;

    constructor(evidence: CauseEvidence, base64: string = null){
        this.base64 = base64 ? base64.substr(base64.indexOf(',') + 1, base64.length) : null;
        this.name = evidence.descripcion;
        this.id = evidence.id;
        this.url = evidence.file_url ? evidence.file_url : null;
    }
}